import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-blueA15",
  "use": "icon-blueA15-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-blueA15\"><defs><style type=\"text/css\"></style></defs><path d=\"M65.582671 288.791335l446.417329 446.41733 446.417329-446.41733z\" p-id=\"2400\" fill=\"#bbbbbb\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol